export const SET_ITEMS = 'items/setItems'
export const LOADING_ITEMS = 'items/loading'
export const LOADED_ITEMS = 'items/loaded'
export const RESET_ITEMS = 'items/reset'

export const SET_CATEGORIES = 'categories/setCategories'
export const LOADING_CATEGORIES = 'categories/loading'
export const LOADED_CATEGORIES = 'categories/loaded'
export const RESET_CATEGORIES = 'categories/reset'
